<div class="column-manager">
  <kendo-listview [data]="columns" class="column-manager-list">
    <ng-template kendoListViewItemTemplate let-column="dataItem">
      <kendo-checkbox
        [checkedState]="column.fixed || !(column.hidden ?? false)"
        [disabled]="column.fixed"
        (checkedStateChange)="toggleColumnVisibility(column)"
      ></kendo-checkbox>
      <kendo-label><span *ngIf="column.group != null">{{ column.group }} - </span> {{ column.title }}</kendo-label>
    </ng-template>
  </kendo-listview>
</div>
